<template>
  <v-snackbar
    v-model="snackbar"
    :color="color"
    :multi-line="mode === 'multi-line'"
    :timeout="!action ? (timeout || 4000) : -1"
    :vertical="mode === 'vertical'"
  >
    {{ text }}
    <v-btn
      v-if="action"
      dark
      text
      @click="typeof action.callback == 'function' ? action.callback() : snackbar=false"
    >
      {{ action.label || $t('GENERIC_CLOSE') }}
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Snackbar',
  props: ['visible', 'color', 'timeout', 'text', 'action'],
  data() {
    return {
      mode: '',
    }
  },
  computed: {
    snackbar: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
}
</script>

<style>

</style>
